import LocalizationManager from './LocalizationManager';

const Localization = LocalizationManager;

export default Localization;
